import React from 'react';
import { getIntl } from '../../../utils/intl';
import { useCapturedUrlUserType } from '../../../hooks/useUrlAppParams';
import Chip from '../../v2BaseComponents/Chip';

const intl = getIntl('ProfessionalIndicator', {
    professionalIndicator: 'Professional',
});

export type ProfessionalIndicatorOwnProps = {};

export type ProfessionalIndicatorProps = ProfessionalIndicatorOwnProps;

const ProfessionalIndicator: React.FC<ProfessionalIndicatorProps> = (_props) => {
    const urlUserType = useCapturedUrlUserType();

    if (urlUserType !== 'professional') return null;

    return <Chip title={intl('professionalIndicator')} highlight />;
};

export default React.memo(ProfessionalIndicator);
